import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { LabelChip } from '@components/Label';

export const EntityChip = ({ label }) => (
    <LabelChip
        label={
            <Typography variant="caption" sx={{ display: 'block', height: 14 }}>
                {label}
            </Typography>
        }
        sx={{ margin: '0 3px 3px 0' }}
    />
);

export const ChipsCell = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    minWidth: 160,
});
